import _get from 'hs-lodash/get';
import { onResponse } from 'hub-http/middlewares/core';
import Raven from 'raven-js';
import { ERROR_STATUS_CODES, STATUS_CODES } from '../../constants/Http';
import { ERROR_CALLBACK_TYPES } from '../../constants/errors';
import { actions } from '../../contexts/error/context';
import errorCallbacks from '../errorCallbacks';
import { isKnownError } from '../errors';
import { history, isAcceptanceTestOrDev } from '../general';
import { addPortalIdParam, markResponseSentryEventAsHandled, urlToAction } from '../helpers';
const authenticationAlertMiddleware = ({
  unauthorizedUrl,
  accountsUrl,
  acceptanceTestBaseRoute
}) => options => onResponse(response => {
  if (response.isErrorHandled || response.options.ignoreErrors) return response;
  const status = response.status;
  const errorMessage = response.responseText;
  if ((status >= STATUS_CODES.BAD_REQUEST || status === STATUS_CODES.NETWORKERROR && response.errorCode !== ERROR_STATUS_CODES.ABORT) && !isKnownError(errorMessage, status)) {
    const message = _get(response, 'responseJSON.message', 'api error');
    const requestArgument = _get(response, 'options.data', '');
    const action = `${response.options.method}->${urlToAction(response.options.url)}`;
    markResponseSentryEventAsHandled(response);
    if (!isAcceptanceTestOrDev) {
      Raven.captureMessage(`Request ${action} failed with status ${response.status}`, {
        extra: {
          action,
          responseMessage: response.responseJSON || errorMessage,
          errorMessage: response.errorMessage,
          requestArgument,
          url: response.options.url,
          statusText: response.statusText,
          errorCode: response.errorCode
        }
      });
    } else {
      console.error(`error timestamp: ${new Date().toISOString()}`);
      console.error(errorMessage);
      console.error(`cookies: ${document.cookie}`);
    }

    // requests handled by callback
    switch (response.options.errorCallback) {
      case ERROR_CALLBACK_TYPES.callObject:
        {
          errorCallbacks[response.options.errorCallback]();
          response.isErrorHandled = true;
          return response;
        }
      case ERROR_CALLBACK_TYPES.authentication:
        {
          errorCallbacks[response.options.errorCallback]({
            accountsRoute: accountsUrl,
            reconnectRoute: unauthorizedUrl,
            acceptanceTestBaseRoute,
            response
          });
          response.isErrorHandled = true;
          return response;
        }
      default:
    }
    switch (status) {
      case STATUS_CODES.UNAUTHORIZED:
      case STATUS_CODES.FORBIDDEN:
        actions.setError({
          showError: true,
          message,
          ctaFunction: () => {
            history.push(addPortalIdParam(unauthorizedUrl));
          }
        });
        response.isErrorHandled = true;
        break;
      default:
        break;
    }
  }
  return response;
})(options);
export default authenticationAlertMiddleware;